import { put, call, take, fork } from 'redux-saga/effects'
import { getPrimaryInterestsService } from '../../api/marketing'
import {
  marketingGetPrimaryInterestsSuccess,
  marketingGetPrimaryInterestsError,
} from '../../reducers/marketing/action'
import { MARKETING_GET_PRIMARY_INTERESTS } from '../../reducers/marketing/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 * Get primary interests flow
 * @param {*} payload
 */
function* marketingGetPrimaryInterestsFlow(payload) {
  try {
    const response = yield call(getPrimaryInterestsService)

    yield put(marketingGetPrimaryInterestsSuccess(response.data))
    yield put(operationSuccess())
  } catch (error) {
    yield put(marketingGetPrimaryInterestsError())
    yield put(operationFail(error))
  }
}

/**
 * Get primary interests watcher
 */
export default function* marketingGetPrimaryInterestsWatcher() {
  while (true) {
    const action = yield take(MARKETING_GET_PRIMARY_INTERESTS)
    const { payload } = action

    yield fork(generalSaga, marketingGetPrimaryInterestsFlow, payload)
  }
}
